import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Seo, { faqLd, serviceLd } from './Seo';
import { Faq } from './product/ProductKit';

/** Search tags for a solutions page (title, description, breadcrumbs, Service and FAQ schema). */
export const SolutionSeo = ({ s, name }) => (
  <Seo
    title={s.seo.title}
    description={s.seo.description}
    path={s.path}
    breadcrumbs={[{ name, path: s.path }]}
    jsonLd={[serviceLd({ name: s.seo.title, description: s.seo.description, path: s.path }), faqLd(s.faqs)]}
  />
);

/** Intro, related products and FAQs for a solutions page (content from data/solutions.js). */
const SolutionExtras = ({ s }) => (
  <>
    <section className="px-4 sm:px-6 lg:px-8 mb-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-10 items-start">
        <div className="lg:col-span-2">
          <h2 className="text-3xl font-bold mb-4" style={{ color: '#0a1f2e' }}>{s.intro.title}</h2>
          {s.intro.paragraphs.map((p) => <p key={p} className="text-lg text-gray-600 mb-4 leading-relaxed">{p}</p>)}
        </div>
        <div className="rounded-xl bg-[#0a1f2e] p-6 text-white">
          <h3 className="text-lg font-bold mb-4 text-[#c8ff00]">Products that fit</h3>
          <ul className="space-y-3">
            {s.products.map((p) => (
              <li key={p.to}>
                <Link to={p.to} className="inline-flex items-center gap-2 hover:text-[#c8ff00]">
                  <ArrowRight className="w-4 h-4" /> {p.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
    <Faq faqs={s.faqs} />
  </>
);

export default SolutionExtras;
